<template>
  <SectionContentLayout 
    content_class="contacts-duplicate-finder">
    <template #close>
      <ActionButton
          @click='close()'
          v-tooltip='"contacts.actions.close"'
          class="close"
          icon="fas fa-times-circle"
        />
    </template>

    <template #header>
        <ContentTitle title="contacts.duplicate_finder.title"/>
    </template>

    <template #content>
      <div class="form">
            <fieldset>
                <p>{{Language.say('contacts.duplicate_finder.duplicated_text1')}} <br/>
                  {{Language.say('contacts.duplicate_finder.duplicated_text2')}}
                </p>


                <p><strong>{{contacts_duplicates_list.count}} {{Language.say('contacts.duplicate_finder.duplicated_contacts')}}</strong></p>

                <div class="contact-list" >
                    <div v-for="(contacts, email_index) in contacts_duplicates_list.duplicates" 
                      :key="email_index"
                      @click="onContactsDuplicatesList(email_index)">
                        <p>
                            <span>{{ email_index }}</span>
                            <span class="counter">{{ contacts.count }}</span>
                        </p>
                    </div>
                </div>
            </fieldset>

        </div>
    </template>
  </SectionContentLayout>
</template>

<script setup>
  import { defineEmits, onBeforeMount } from 'vue'
  import { useRouter }        from 'vue-router';
  import SectionContentLayout from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language from '@/js/Shared/Language/Language';
  import ActionButton from '@/vue/Elements/Buttons/ActionButton.vue';
  import ContentTitle from '@/vue/Elements/Content/ContentTitle.vue';

  const props = defineProps({
    contacts_duplicates_list: {},
    contacts_selection : {},
  });

  const emit = defineEmits([
    'contactsDuplicatesList',
  ]);

  const router = useRouter();

  onBeforeMount(() => {
    props.contacts_selection.reset();
  });

  const onContactsDuplicatesList = (email) => {
    emit('contactsDuplicatesList', email);
  }

  const close = () => {
    router.push('/contacts');
  }
</script>